/* rt-header-dropdown-clamp:v1 */
/* rt-header-dropdown-columns:v1 (in rt-header-dropdown-compact.css) lets a
   tall dropdown flow into extra columns instead of scrolling - which also
   makes the panel WIDER (width:max-content). Widening is fine for a
   left-edge trigger like RECORDS, but a trigger further along the nav
   (EQUIPMENT, 3rd of 6) can run the panel off the right edge of the
   viewport once it's wide enough - confirmed on FR (longer labels): panel
   ran ~104px past the viewport edge, clipping the second column.
   No static width/position fixes this for every viewport size and every
   trigger position at once, so this clamps on open instead: measure the
   panel, and if its right edge would overflow, pull it left by exactly that
   much (capped so it can't be pushed past the left edge either).
   Uses margin-left, NOT transform: base.css's details[open] > .header__submenu
   animation (animateMenuOpen, animation-fill-mode:forwards) drives transform
   on this same element and holds its own value indefinitely once the open
   animation finishes, silently overwriting any inline transform set here.
   margin-left isn't touched by that animation.
   Small dropdowns that never overflow never get a margin change - no visual
   change for them. Re-runs on resize for any dropdown left open. */
(function () {
  function clampSubmenu(details) {
    var submenu = details.querySelector(':scope > ul.header__submenu');
    if (!submenu) return;
    submenu.style.marginLeft = '';
    var rect = submenu.getBoundingClientRect();
    var overflow = rect.right - (window.innerWidth - 8);
    if (overflow > 0) {
      var maxShift = rect.left - 8;
      var shift = Math.min(overflow, maxShift);
      if (shift > 0) submenu.style.marginLeft = '-' + Math.round(shift) + 'px';
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    var triggers = document.querySelectorAll('.header__inline-menu header-menu > details');
    triggers.forEach(function (details) {
      details.addEventListener('toggle', function () {
        if (details.open) clampSubmenu(details);
      });
    });
    window.addEventListener('resize', function () {
      document.querySelectorAll('.header__inline-menu header-menu > details[open]').forEach(clampSubmenu);
    });
  });
})();
